/**
 * Standalone onboarding constants with no heavy imports (no AppController /
 * Amplify), so they can be imported from bootstrap paths like `useRouterHook`
 * without dragging the whole app-composition graph into their test transforms.
 */

/**
 * Stores the normalized email of a user who still owes onboarding (invited
 * signups and first-time PCC SSO users). Cleared once onboarding reaches
 * "completed". Scoping the value to an identity prevents a later account on the
 * same browser from inheriting it.
 */
export const ONBOARDING_PENDING_KEY = "onboardingPending";
